/**
 * 订单配置信息，包含订单相关的配置
 */
// import * as Names from './statuses'
import flowConfigs from './flows'
// 默认订单流程 - 远盟/理化所
const DEFAULT_FLOW = 'LAB'
const ACTIONS = 'LIFEBANK_ACTIONS'
const ADULT_ACTIONS = 'ADULT_LIFEBANK_ACTIONS'
const ADULT_SELL_ORDER = 'ADULT_SELL_ORDER'

/**
 * 获取默认的订单状态流程
 */
function getDefaultOrderFlow (isClosed, isAdult = false) {
  if (isAdult) {
    return getAdultSellOrder()
  }
  let flows = getOrderFlow(DEFAULT_FLOW).concat()

  // 是否是关闭订单的状态
  if (isClosed) {
    flows.forEach((e, index) => {
      if (e.name === 'COMPLETED') {
        flows.splice(index, 1)
      }
    })
  } else {
    flows.forEach((e, index) => {
      if (e.name === 'CLOSED') {
        flows.splice(index, 1)
      }
    })
  }
  return flows
}

function getActions (isAdult = false) {
  let targetAction = isAdult ? ADULT_ACTIONS : ACTIONS
  let flows = getOrderFlow(targetAction).concat()
  return flows
}
function getAdultSellOrder (lastStatus = 'COMPLETED') {
  let flows = getOrderFlow(ADULT_SELL_ORDER).concat()
  // 获取流程中不属于最后环节的流程
  let primaryStatuses = flows.filter(e => !e.hasOwnProperty('lastStatus'))
  // 获取流程中的最后环节
  let lastItem = flows.filter(e => e.lastStatus && e.name === lastStatus)
  lastItem.length && (primaryStatuses.push(lastItem[0]))
  return primaryStatuses
}

/**
 * 获取指定产品的订单流程，返回一个状态对象的有序数组
 * @param {*} name
 */
function getOrderFlow (name) {
  for (let flowConfig of flowConfigs) {
    if (flowConfig.name === name) {
      return flowConfig.statuses
    }
  }
  return null
}

/**
 * 根据传入的状态获取下一个状态
 * @param {*string} name
 * @param {*string} currentStatus
 */
function getNextOrderStatus (name, currentStatus, onlyStatusCode = false) {
  let orderflow = getOrderFlow(name)

  let currentStatusIndex = orderflow.findIndex(val => val.name === currentStatus)

  let nextStatusIndex = currentStatusIndex + 1
  if (nextStatusIndex > 0 && orderflow[nextStatusIndex]) {
    return onlyStatusCode ? orderflow[nextStatusIndex].name : orderflow[nextStatusIndex]
  } else {
    console.warn('未找到下一个状态信息')
    return ''
  }
}

/**
 * 查询订单流程是否结束
 * @param {*string} status
 */
function isComplete (name, currentStatus) {
  let orderflow = getOrderFlow(name)

  let currentStatusIndex = orderflow.findIndex(val => val.name === currentStatus)
  return orderflow.length === (currentStatusIndex + 1)
}
/**
 * 格式化订单状态用于order-list
 * example:"CREATED"=>'样本接收'
 * @param {*} value
 */
function formatOrderStatus (value) {
  let orderFlow = getDefaultOrderFlow()

  for (let item of orderFlow) {
    if (item.name === value) {
      let currentStatusIndex = orderFlow.findIndex(val => val.name === value)
      if (currentStatusIndex === orderFlow.length - 1) {
        return orderFlow[currentStatusIndex].description
      }
      // 直销商不显示数据质控状态
      if (DEFAULT_FLOW === 'DISTRIBUTION' && value === 'LAB_DNA_TESTED') {
        return orderFlow[currentStatusIndex].operation
      }
      return orderFlow[currentStatusIndex + 1].operation
    }
  }
  return ''
}
/**
 * 格式化订单状态
 * example:"LAB_SAMPLES_RECEIVED"=>'样本接收'
 * @param {*} value
 */
function formatTargetOrderStatus (value, isAdult = false) {
  let orderFlow = getDefaultOrderFlow(false, isAdult)

  for (let item of orderFlow) {
    if (item.name === value) {
      let currentStatusIndex = orderFlow.findIndex(val => val.name === value)
      if (currentStatusIndex === orderFlow.length - 1) {
        return orderFlow[currentStatusIndex].description
      }
      return orderFlow[currentStatusIndex].operation
    }
  }
  return ''
}

/**
 * 将订单操作转换为对应的描述
 * @param {*} value
 */
function formatOrderActions (value, isAdult = false) {
  let actions = getActions(isAdult)
  for (let item of actions) {
    if (item.name === value) {
      return item.description
    }
    if (value === 'NONE') {
      return actions.pop().description
    }
  }
  return ''
}
/**
 * 根据状态判断是否可操作
 * @param {*} value
 */
function canNotOperation (nextStatus, order) {
  // 不可操作的状态
  let canNOtOperation = ['COMPLETED', 'REPORT_CREATED']
  if (nextStatus) {
    if (canNOtOperation.includes(nextStatus)) {
      return true
    }
  }
  return false
}
/**
 * 获取对应的流程tag
 * @param {*} value
 */
function getStatusTag (status, isAdult = false) {
  let flows = getDefaultOrderFlow(false, isAdult)
  let targetItem = flows.filter(e => e.name === status).length ? flows.filter(e => e.name === status)[0] : null
  return targetItem ? targetItem.tag : ''
}
export default {
  // statuses以及getStatus暂时注释，需重新设计
  // statuses,
  // getStatus,
  getOrderFlow,
  getActions,
  getDefaultOrderFlow,
  getNextOrderStatus,
  isComplete,
  formatOrderStatus,
  formatOrderActions,
  formatTargetOrderStatus,
  canNotOperation,
  getAdultSellOrder,
  getStatusTag
}
